import type { EntityMap } from '../types';
import type { FilterOptions } from './types';
import type { ActivityType } from 'types';
import type { EmbeddedOutletOrServiceCategory } from 'modules/supplier/outletOrServiceCategory/types';

export function createFilterOptions({ company, activity, block, product }: EntityMap): FilterOptions {
  const outletOrCatMap: Record<number, EmbeddedOutletOrServiceCategory> = {};

  const types: ActivityType[] = [];
  // const types

  for (const { outlet_or_service_category, type } of Object.values(product)) {
    if (!outletOrCatMap[outlet_or_service_category.id]) {
      outletOrCatMap[outlet_or_service_category.id] = outlet_or_service_category;
    }
    if (!types.includes(type)) {
      types.push(type);
    }
  }

  return {
    activity: Object.values(activity),
    outlet_or_service_category: Object.values(outletOrCatMap),
    company: Object.values(company),
    block: Object.values(block),
    type: types.map((value) => ({
      value,
      label: value,
    })),
  };
}
